import { SEOHead } from '../components/SEOHead';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { REVIEWS_DATA, REVIEWS_TOTAL } from '../data/reviewsData';
import { TRIPADVISOR_RATING } from '../data/reviewStats';
import { translations } from '../translations';

export default function ReviewsPage({ language, setLanguage }) {
  const t = translations[language];
  const isAr = language === 'ar';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Client Reviews — Viaturkey Istanbul Tours",
    "url": "https://viaturkey.net/reviews",
    "about": { "@type": "TravelAgency", "@id": "https://viaturkey.net/#travel-agency", "name": "Viaturkey Investments & Tourism Co." }
  };

  return (
    <div className="reviews-page" dir={isAr ? 'rtl' : 'ltr'} data-testid="reviews-page">
      <SEOHead
        title={isAr ? 'تقييمات العملاء لجولات إسطنبول | Viaturkey' : 'Client Reviews Istanbul Tours | Viaturkey'}
        description={isAr ? 'اقرأ تقييمات مسافري دول الخليج الذين حجزوا جولات خاصة في إسطنبول ورحلات شاطئية واستشارات عقارية مع Viaturkey.' : 'Read verified reviews from Gulf Arab travelers who booked private Istanbul tours, shore excursions, and real estate consulting with Viaturkey.'}
        canonical="https://viaturkey.net/reviews"
        schema={schema}
      />
      <Header language={language} t={t} />

      <section className="sp-hero" data-testid="reviews-hero">
        <div className="sp-hero-overlay"></div>
        <div className="sp-hero-content">
          <h1>{isAr ? 'تقييمات العملاء' : 'Client Reviews'}</h1>
          <p>{isAr ? 'ماذا يقول ضيوفنا عنّا' : 'What our guests say about their Viaturkey experience'}</p>
        </div>
      </section>

      <div className="sp-container">
        <div className="reviews-summary" data-testid="reviews-summary">
          <div className="reviews-avg">
            <span className="reviews-avg-num">{TRIPADVISOR_RATING}</span>
            <div className="reviews-avg-stars">
              {[...Array(5)].map((_, i) => <i key={`avg-star-${i}`} className="fas fa-star"></i>)}
            </div>
            <span className="reviews-count">{isAr ? <>{TRIPADVISOR_RATING}/5 على TripAdvisor — {REVIEWS_TOTAL} تقييماً موثّقاً</> : <>{TRIPADVISOR_RATING}/5 on TripAdvisor — {REVIEWS_TOTAL} Verified Reviews</>}</span>
            {isAr && <span className="reviews-count" data-testid="reviews-translated-note" style={{display: 'block', marginTop: '0.35rem'}}>تقييمات مترجمة من TripAdvisor</span>}
          </div>
        </div>

        <div className="reviews-grid" data-testid="reviews-grid">
          {REVIEWS_DATA.map((review, i) => (
            <div key={`${review.name}-${review.tour}`} className="review-card" data-testid={`review-card-${i}`}>
              <div className="review-stars">
                {[...Array(5)].map((_, j) => (
                  <i key={`${review.name}-star-${j}`} className={`fas fa-star ${j < review.stars ? 'filled' : 'empty'}`}></i>
                ))}
              </div>
              {review.title && <p className="review-title" data-testid={`review-title-${i}`}>{isAr ? (review.titleAr || review.title) : review.title}</p>}
              <p className="review-quote">"{isAr ? (review.quoteAr || review.quote) : review.quote}"</p>
              <div className="review-footer">
                <div className="review-author">
                  
                  <div>
                    <strong>{review.name}</strong>
                    {review.nationality && <span className="review-nationality">{isAr ? (review.nationalityAr || review.nationality) : review.nationality}</span>}
                  </div>
                </div>
                <span className="review-tour">{isAr ? (review.tourAr || review.tour) : review.tour}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="sp-cta" data-testid="reviews-cta">
          <h2>{isAr ? 'انضم إلى ضيوفنا الراضين' : 'Join Our Satisfied Guests'}</h2>
          <p>{isAr ? 'احجز تجربتك الخاصة في إسطنبول اليوم. خدمة مباشرة، بدون وسطاء، بدون رسوم مخفية.' : 'Book your private Istanbul experience today. Direct service, no middlemen, no hidden fees.'}</p>
          <a href="https://wa.me/905075337545?text=Hi%20Viaturkey!%20I%20read%20your%20reviews%20and%20I'd%20like%20to%20book%20a%20tour." target="_blank" rel="noopener noreferrer" className="sp-cta-btn" data-testid="reviews-whatsapp-btn">
            <i className="fab fa-whatsapp"></i> {isAr ? 'راسلنا على واتساب' : 'Message Us on WhatsApp'}
          </a>
        </div>
      </div>

      <Footer t={t} />
    </div>
  );
}
